import { Action } from 'redux';

import { isRefreshSiteMetadataAction } from '../actions/SiteMetadataActions';
import { SiteMetadataState } from '../state/SiteMetadataState';

export const InitialSiteMetadataState: SiteMetadataState = {
  info: null,
};

export function siteMetadataReducer(
  previousState: SiteMetadataState = InitialSiteMetadataState,
  action: Action = null
): SiteMetadataState {

  if (isRefreshSiteMetadataAction(action)) {
    return {
      ...previousState,
      info: action.metadata,
    };
  } else {
    return previousState;
  }
}